<style scoped lang="scss">
$loader-size: 5em;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$check-thickness: 3px;
$check-color: #5cb85c;

.circle {
  margin-right: 10px;
  border: 1px solid $check-color;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: $loader-size;
  height: $loader-size;
}

.checkmark {
  &:after {
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $check-color;
    border-top: $check-thickness solid $check-color;
    content: "";
    left: $check-left;
    top: $check-height;
    position: absolute;
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
  }
  20% {
    height: 0;
    width: $check-width;
  }
  40% {
    height: $check-height;
    width: $check-width;
  }
  100% {
    height: $check-height;
    width: $check-width;
  }
}
</style>

<template>
  <div>
    <img
      class="float-right"
      height="100"
      src="/assets/images/telegram.png"
      alt=""
    />
    <span v-if="(botName && !verification) || verified">
      Dein Profil ist mit deinem Telegram Account verknüpft.
    </span>
    <span v-else>
      Hier kannst du dich mit Telegram verbinden.
    </span>
    <br />
    Durch das Verbinden erhälst du viele Vorteile wie:
    <ul>
      <li>echtzeit Benachrichtigungen ohne Verzögerung</li>
      <li>exklusive Bonuscodes</li>
      <li v-if="dailyBonus">
        tägliches kassieren von zusätzlich {{ dailyBonusAmount }} {{ currency }}
      </li>
      <li v-if="verificationBonus">
        einmaliger Bonus von {{ verificationBonusAmount }} {{ currency }} bei
        erfolgreicher Verbindung
      </li>
    </ul>

    <v-button
      v-if="!botName && !verification && !verified"
      :working="working"
      @click.native="connectTelegram()"
      type="submit"
      class="btn btn-primary"
    >
      Jetzt dein Profil mit Telegram verbinden!
    </v-button>

    <div v-if="botName && verification && !verified">
      Um dein Profil mit deinem Telegram Account zu verküpfen suche in Telegram
      nach dem Nutzer
      <u
        ><b>{{ botName }}</b></u
      >
      und sende diesem folgenden code:
      <b
        ><code>{{ verification }}</code></b
      >
      <br /><br />
      Nach der Verbindung kannst du die Benachrichtigungen unter
      <i style="cursor: pointer;" @click="$emit('set-navigation-key', 3)"
        >Einstellungen / Benachrichtigungen</i
      >
      verwalten.
    </div>

    <div v-if="(botName && !verification) || verified">
      <div class="circle float-left">
        <div class="checkmark"></div>
      </div>
      Dein Profil ist erfolgreich mit deinem Telegram Account verknüpft.
      <br />
      In Zukunft werden wir dich dort benachrichtigen sobald es Neuigkeiten
      gibt.
      <br />
      Deine Benachrichtigungen kannst du unter
      <i style="cursor: pointer;" @click="$emit('set-navigation-key', 3)"
        >Einstellungen / Benachrichtigungen</i
      >
      jederzeit ein- und ausschalten. <br /><br />

      <v-button
        :working="working"
        @click.native="removeConnection()"
        type="submit"
        class="btn btn-danger"
      >
        Verbindung entfernen
      </v-button>
    </div>
  </div>
</template>

<script>
import { bus } from "@/bus";
import swal from "sweetalert2";
export default {
  data() {
    return {
      botName: "",
      verification: "",
      working: false
    };
  },
  created() {
    bus.$on("telegram-was-verified", botName => {
      this.botName = botName;
      this.verification = "";
      Laravel.user.settings.flirtDollarTelegram = true;
      Laravel.user.settings.newMessageTelegram = true;
      Laravel.user.settings.profileVisitTelegram = true;
    });
    this.$store.dispatch("customerProfile/read", [
      {
        name: "where",
        attributes: {
          id: [Number(Laravel.user.customer_profile.id)]
        }
      }
    ]);
  },
  methods: {
    connectTelegram() {
      this.working = true;
      this.$http.get("/api/v1/telegram/setup-for-customer").then(response => {
        this.botName = response.data.botName;
        this.verification = response.data.verification;
        this.working = false;
      });
    },
    removeConnection() {
      swal
        .fire({
          title: "Verknüpfung entfernen?",
          text: "Möchtest du deine Telegram Verknüpfung wirklich entfernen?",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ja",
          cancelButtonText: "Nein",
          type: "warning"
        })
        .then(result => {
          if (result.value) {
            this.working = true;
            this.$http.delete("/api/v1/telegram/remove-customer").then(() => {
              this.botName = "";
              this.verification = "";
              this.working = false;
              this.$store.commit("customerProfile/updateModel", {
                modelId: Laravel.user.customer_profile.id,
                attributePath: "telegram_token",
                data: null
              });
            });
          }
        });
    }
  },
  computed: {
    verified() {
      let customer = this.$store.getters["customerProfile/find"](
        Laravel.user.customer_profile.id
      );
      return customer ? customer.telegram_token : false;
    },
    currency() {
      return Laravel.lang.currency;
    },
    dailyBonus() {
      return Laravel.settings.messengers.telegram.dailyBonus == 1;
    },
    dailyBonusAmount() {
      return Laravel.settings.messengers.telegram.dailyBonusAmount;
    },
    verificationBonus() {
      return Laravel.settings.messengers.telegram.verificationBonus == 1;
    },
    verificationBonusAmount() {
      return Laravel.settings.messengers.telegram.verificationBonusAmount;
    }
  }
};
</script>
